import { atomFamily } from "recoil";

// A chave deste recoil family é a string "pivotid_devicetype"
export const DeviceRadioFamily = atomFamily<string, string>({
  key: "DeviceRadioFamily",
  default: null,
});
